import { createFileRoute } from '@tanstack/react-router';

import { RecuperarPasswordPage } from '@/pages/recuperar-password';

export const Route = createFileRoute('/_public/recuperar-password')({
  component: RecuperarPasswordPage,
});
